import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Texts } from '../../../../../../../core/entities/texts.model';
import { TextsService } from '../../../../../../../core/repositories/texts.service';
import { BOOLEAN_OPTION } from '../../../../../../../core/utils/constants';

@Injectable()
export class EditDialogsTextsService {

  text: Texts = new Texts();
  originalTexts: Texts = new Texts();
  TextsInput: Texts = new Texts();

  allTexts: Texts[] = [];
  changetitulo: boolean = false;

  enable: any[] = BOOLEAN_OPTION;

  constructor(private textsService: TextsService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.text = data.text;
    this.changetitulo = data.titulochange;
    this.originalTexts = _.cloneDeep(this.text);
    console.log(data);
    return this.textsService.findAll().pipe(map((result: Texts[]) => {
      this.allTexts = result;
      if (Utils.noUndfAndNull(data.text)) {
        this.text = _.cloneDeep(data.text);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el text
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.text.code, "")) {

      /*comparamos el ca original con el modificado*/
      let compareText = this.compare(this.text, this.originalTexts);

      if(compareText){
        return of(-1);
      }else{
        return this.textsService.postText(this.text);
      }

    } else {
        return this.textsService.postText(this.text);
    }
  }

  /**
  * @description
  * Comprueba si dos Texts son iguales.
  * @param datoX Ca 1
  * @param datoY Ca 2
  * @returns True si son iguales
  */
  public compare(itemX:Texts, itemY:Texts):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.enable !== null) {
        let value = itemX.enable.toString();
        if (value === 'null') {
          itemX.enable = 0;
        }
      }

      if(itemY.code == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
        || !Utils.compareTextOrNumber(itemX.desc, itemY.desc)
        || !Utils.compareTextOrNumber(itemX.valuecat, itemY.valuecat)
        || !Utils.compareTextOrNumber(itemX.valueesp, itemY.valueesp)
        || !Utils.compareTextOrNumber(itemX.enable, itemY.enable)
        ) && (itemX.code !== "" && Utils.noUndfAndNull(itemX.enable)))
          return false;
      }
    }
   //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
   else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
     return false;
   }
   return true;
 }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.text = new Texts();
  }

}